"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  uuid: '',
  name: '',
  flowId: null,
  flowObjectType: 'QUOTE',
  isEnabled: true,
  shouldReenroll: true,
  firstActionId: 1,
  actions: (0, _immutable.List)(),
  associatedLists: (0, _immutable.List)()
});

exports.default = _default;
module.exports = exports.default;